import React, { useEffect, useState } from "react";
import { Button, Form, Spin, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
	fetchSurveyScores,
	updateSurveyScore,
} from "../../actions/surveyScore";

import SurveyScoresTable from "../Tables/SurveyScores";
import { PAGE_SIZE } from "../../constants";
import { Link } from "react-router-dom";
import SurveyScoreForm from "../Forms/SurveyScore";
const SurveyScoresPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [surveyScoreId, setSurveyScoreId] = useState(null);
	const [pagination, setPagination] = useState({});
	const [currentPage, setCurrentPage] = useState(1);
	const limit = Number(PAGE_SIZE) || 20;
	const { surveyScores, status, loading } = useSelector(
		(state) => state.fetchSurveyScores,
	);
	const { status: updateStatus } = useSelector(
		(state) => state.updateSurveyScore,
	);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleEdit = (record) => {
		showModal();
		setSurveyScoreId(record.id);
		const newRecord = { ...record };
		const newProductIds = newRecord.product_ids
			? newRecord.product_ids.ids
			: null;
		const productDescription = newRecord.product_ids
			? newRecord.product_ids.description
			: null;
		const productStatus = newRecord.product_ids
			? newRecord.product_ids.status
			: null;
		const productRecommendation = newRecord.product_ids
			? newRecord.product_ids.recommendation
			: null;
		newRecord.product_ids = newProductIds;
		newRecord.product_description = productDescription;
		newRecord.product_status = productStatus;
		newRecord.product_recommendation = productRecommendation;
		form.setFieldsValue(newRecord);
	};

	const handleSubmitForm = (values) => {
		const newValues = { ...values };
		const newProduct = {
			ids: values.product_ids,
			description: values.product_description,
			status: values.product_status,
			recommendation: values.product_recommendation,
		};
		newValues.product_ids = values.product_ids ? newProduct : null;
		delete newValues.product_description;
		delete newValues.product_status;
		delete newValues.product_recommendation;
		delete newValues.product_description;
		dispatch(updateSurveyScore(surveyScoreId, newValues));
		handleOk();
	};

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Link to={`/survey-scores/${record.id}`}>
					<Button type="link" className="btn-table-action-primary">
						Show
					</Button>
				</Link>
				<Button
					type="link"
					className="btn-table-action-primary"
					onClick={() => handleEdit(record)}
				>
					Edit
				</Button>
			</span>
		);
	};

	const handleFilter = (params) => {
		setCurrentPage(params.page);
		const startAt = (params.page - 1) * Number(PAGE_SIZE);
		dispatch(fetchSurveyScores({ start: Number(startAt), count: PAGE_SIZE }));
	};

	const handleTableChange = (params) => {
		handleFilter(params);
	};

	useEffect(() => {
		dispatch(fetchSurveyScores({ start: 0, count: PAGE_SIZE }));
	}, []);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED")
			dispatch(fetchSurveyScores({ start: 0, count: PAGE_SIZE }));
	}, [updateStatus]);

	useEffect(() => {
		if (surveyScores) {
			setPagination({
				showSizeChanger: false,
				current: currentPage,
				pageSize: limit,
				total: surveyScores.total,
				showTotal: (total) => `${total} Items`,
			});
		}
	}, [surveyScores]);

	return (
		<div className="categories-container">
			<div className="page-header">
				<div className="page-header-breadbrumb">
					<ul>
						<li>Survey Scores</li>
					</ul>
				</div>
			</div>
			<div className="page-content">
				{status === "SUCCEEDED" && (
					<Spin spinning={loading}>
						<SurveyScoresTable
							rowKey="id"
							pagination={pagination}
							onChange2={handleTableChange}
							dataSource={surveyScores.data}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={150}
							withAction={withAction}
						/>
					</Spin>
				)}
			</div>
			<Modal
				className="topic-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<SurveyScoreForm
					form={form}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
				/>
			</Modal>
		</div>
	);
};

export default SurveyScoresPage;
